export enum FEATURE_FLAGS {
  AI_TEXTS = 'AI_TEXTS',
  AI_TRANSLATION = 'AI_TRANSLATION',
  AI_USAGE = 'AI_USAGE',
  BACKUP_GENIALLY_CONTENT_BEFORE_SVG_MIGRATION = 'BACKUP_GENIALLY_CONTENT_BEFORE_SVG_MIGRATION',
  BRAND_TEMPLATES_GENERATOR = 'BRAND_TEMPLATES_GENERATOR',
  CANNY = 'CANNY',
  CLOSE_POPUP_INTERACTIVITY = 'CLOSE_POPUP_INTERACTIVITY',
  COMMUNITY_IN_TEMPLATES = 'COMMUNITY_IN_TEMPLATES',
  COM_MIGRATION_REDIRECTION = 'COM_MIGRATION_REDIRECTION',
  DISABLE_LOGROCKET = 'DISABLE_LOGROCKET',
  EDU_FAKE_PRICES = 'EDU_FAKE_PRICES',
  ENABLE_EMBEDDED_DOMAINS_FEAT_FOR_AUTHOR_WS = 'ENABLE_EMBEDDED_DOMAINS_FEAT_FOR_AUTHOR_WS',
  ENABLE_VWO = 'ENABLE_VWO',
  FEAT_ENABLE_KUSTOMER_CHAT = 'FEAT_ENABLE_KUSTOMER_CHAT',
  FEAT_GALLERY_TYPES = 'FEAT_GALLERY_TYPES',
  FEAT_IMPROVE_CHART_READABILITY = 'FEAT_IMPROVE_CHART_READABILITY',
  FEAT_LT1_GENIALLY_READONLY_COLABORATIONS = 'FEAT_LT1_GENIALLY_READONLY_COLABORATIONS',
  FEAT_LT1_MEMBER_DETAILS = 'FEAT_LT1_MEMBER_DETAILS',
  FEAT_LT2_CARDS = 'FEAT_LT2_CARDS',
  FEAT_LT2_SEQUENCE_CARDS = 'FEAT_LT2_SEQUENCE_CARDS',
  FEAT_LT2_CARD_ANIMATIONS_SELECTABLE_IN_EDITOR = 'FEAT_LT2_CARD_ANIMATIONS_SELECTABLE_IN_EDITOR',
  FEAT_LT2_NEW_TRANSVERSALITY = 'FEAT_LT2_NEW_TRANSVERSALITY',
  FEAT_LT2_ENABLE_WIDGETS_IN_SMARTBLOCKS = 'FEAT_LT2_ENABLE_WIDGETS_IN_SMARTBLOCKS',
  FEAT_LT2_ENABLE_FIND_THE_PAIR = 'FEAT_LT2_ENABLE_FIND_THE_PAIR',
  FEAT_LT4_DOWNLOAD_SCORM = 'FEAT_LT4_DOWNLOAD_SCORM',
  FEAT_LT4_FILL_IN_THE_BLANKS = 'FEAT_LT4_FILL_IN_THE_BLANKS',
  FEAT_LT4_IMAGE_SURVEY = 'FEAT_LT4_IMAGE_SURVEY',
  FEAT_LT4_INTERACTIVE_QUESTIONS_WITH_AI = 'FEAT_LT4_INTERACTIVE_QUESTIONS_WITH_AI',
  FEAT_LT4_JOIN_TO_PLAY_FEAT_TOAST = 'FEAT_LT4_JOIN_TO_PLAY_FEAT_TOAST',
  FEAT_LT4_PLAY = 'FEAT_LT4_PLAY',
  FEAT_LT4_PLAY_BENCHMARK = 'FEAT_LT4_PLAY_BENCHMARK',
  FEAT_LT4_PLAY_SKIP_SESSION_PLAYER_LIMITS = 'FEAT_LT4_PLAY_SKIP_SESSION_PLAYER_LIMITS',
  FEAT_LT4_PRESENT_FLOW_ADJUSTMENTS = 'FEAT_LT4_PRESENT_FLOW_ADJUSTMENTS',
  FEAT_LT4_SHORT_ANSWER = 'FEAT_LT4_SHORT_ANSWER',
  FEAT_LT4_VIEW_AUDIENCE_LIMIT = 'FEAT_LT4_VIEW_AUDIENCE_LIMIT',
  FEAT_LT4_VIEW_DYNAMIZATION = 'FEAT_LT4_VIEW_DYNAMIZATION',
  FEAT_LT5_AUTOMATIC_GENIALLY_TITLE = 'FEAT_LT5_AUTOMATIC_GENIALLY_TITLE',
  FEAT_LT5_GENERATE_IMAGE_WITH_AI = 'FEAT_LT5_GENERATE_IMAGE_WITH_AI',
  FEAT_LT5_GENERATE_IMAGE_WITH_AI_TRACKING = 'FEAT_LT5_GENERATE_IMAGE_WITH_AI_TRACKING',
  FEAT_LT5_MASSIVE_SET_COLOR = 'FEAT_LT5_MASSIVE_SET_COLOR',
  FEAT_LT5_EDITOR_TAB_STYLES = 'FEAT_LT5_EDITOR_TAB_STYLES',
  FEAT_LT5_TTS_AUDIOS = 'FEAT_LT5_TTS_AUDIOS',
  FEAT_LT5_UPLOAD_VIDEOS_TRACKING = 'FEAT_LT5_UPLOAD_VIDEOS_TRACKING',
  FEAT_LT6_NEW_PUBLISH_FLOW = 'FEAT_LT6_NEW_PUBLISH_FLOW',
  FEAT_LT6_NEW_PUBLISH_FLOW_II_PHASE = 'FEAT_LT6_NEW_PUBLISH_FLOW_II_PHASE',
  FEAT_LT6_NEW_PUBLISH_FLOW_PANEL = 'FEAT_LT6_NEW_PUBLISH_FLOW_PANEL',
  FEAT_LT8_GENERATE_QUIZZES = 'FEAT_LT8_GENERATE_QUIZZES',
  FEAT_LTI_CONFIGURATION = 'FEAT_LTI_CONFIGURATION',
  FEAT_NEW_SUMMARY_HELP_MODAL = 'FEAT_NEW_SUMMARY_HELP_MODAL',
  FEAT_PRECONFIG_INTERACTIVE_QUESTIONS = 'FEAT_PRECONFIG_INTERACTIVE_QUESTIONS',
  FULL_LIVE_COLLABORATION = 'FULL_LIVE_COLLABORATION',
  FULL_LIVE_COLLABORATION_FOR_FREE = 'FULL_LIVE_COLLABORATION_FOR_FREE',
  INTERACTIVITY_HIGHLIGHTS_BOTTOM_ACTIONS = 'INTERACTIVITY_HIGHLIGHTS_BOTTOM_ACTIONS',
  INTERACTIVITY_HIGHLIGHTS_MENU = 'INTERACTIVITY_HIGHLIGHTS_MENU',
  LT1_COMMENTS = 'LT1_COMMENTS',
  LT3_NO_ORGANIC_SUBSCRIPTION = 'LT3_NO_ORGANIC_SUBSCRIPTION',
  LT5_TRACK_DOCUMENT_COLOR_SETTING = 'LT5_TRACK_DOCUMENT_COLOR_SETTING',
  LT5_TRACK_GENIALLY_DELETION = 'LT5_TRACK_GENIALLY_DELETION',
  MASSIVE_MEMBERS_PROMOTE = 'MASSIVE_MEMBERS_PROMOTE',
  MEASURE_SNOWPLOW_CONTEXTUAL_MENU = 'MEASURE_SNOWPLOW_CONTEXTUAL_MENU',
  MEASURE_SNOWPLOW_DRAG_MODE = 'MEASURE_SNOWPLOW_DRAG_MODE',
  MEASURE_SNOWPLOW_DRAW_MODE = 'MEASURE_SNOWPLOW_DRAW_MODE',
  MEASURE_SNOWPLOW_MULTI_INTERACTIVITY = 'MEASURE_SNOWPLOW_MULTI_INTERACTIVITY',
  MIGRATION_AUTO_EDU_ENABLED = 'MIGRATION_AUTO_EDU_ENABLED',
  MIGRATION_AUTO_ENABLED = 'MIGRATION_AUTO_ENABLED',
  MIGRATION_AUTO_FREE_ENABLED = 'MIGRATION_AUTO_FREE_ENABLED',
  MIGRATION_AUTO_FREE_STUDENT_ENABLED = 'MIGRATION_AUTO_FREE_STUDENT_ENABLED',
  MIGRATION_AUTO_STUDENT_ENABLED = 'MIGRATION_AUTO_STUDENT_ENABLED',
  MIGRATION_AUTO_STUDENT_WITH_ROLE_STUDENT_ENABLED = 'MIGRATION_AUTO_STUDENT_WITH_ROLE_STUDENT_ENABLED',
  NEW_INSERT_URL_MODAL = 'NEW_INSERT_URL_MODAL',
  NEW_MOBILE_SIZE = 'NEW_MOBILE_SIZE',
  NEW_PDF_DOWNLOAD = 'NEW_PDF_DOWNLOAD',
  NEW_SCREENSHOTTER = 'NEW_SCREENSHOTTER',
  NV_US_CHILD = 'NV_US_CHILD',
  OPS_ENABLE_KUSTOMER_SERVICE = 'OPS_ENABLE_KUSTOMER_SERVICE',
  OPS_HIDDEN_PREMIUM_CTAS = 'OPS_HIDDEN_PREMIUM_CTAS',
  OPS_INTERNAL_EDITOR_TOOLS = 'OPS_INTERNAL_EDITOR_TOOLS',
  OPS_PLUGIN_DEVELOPER = 'OPS_PLUGIN_DEVELOPER',
  OPS_FIX_ORPHANS_INTERACTIVITIES = 'OPS_FIX_ORPHANS_INTERACTIVITIES',
  OPS_DELETE_ORPHANS_INTERACTIVITIES = 'OPS_DELETE_ORPHANS_INTERACTIVITIES',
  PAYMENT_MODAL_FLOW = 'PAYMENT_MODAL_FLOW',
  PRICE_GROUP = 'PRICE_GROUP',
  PRICE_IVA = 'PRICE_IVA',
  RESPONSIVE_COPY = 'RESPONSIVE_COPY',
  RESPONSIVE_PREVIEW = 'RESPONSIVE_PREVIEW',
  RESPONSIVE_REEL = 'RESPONSIVE_REEL',
  RESTRICTED_GENIALLY = 'RESTRICTED_GENIALLY',
  SALE_CAMPAIGN = 'SALE_CAMPAIGN',
  SALE_CAMPAIGN_UPGRADE = 'SALE_CAMPAIGN_UPGRADE',
  SELECTABLE_TEXT_PDF = 'SELECTABLE_TEXT_PDF',
  SHOW_GOOGLE_DRIVE = 'SHOW_GOOGLE_DRIVE',
  STRIPE_PAYPAL = 'STRIPE_PAYPAL',
  SUBSCRIPTION_TRIAL = 'SUBSCRIPTION_TRIAL',
  TEAM_STORAGE_ENABLED = 'TEAM_STORAGE_ENABLED',
  TEST_SALE_CAMPAIGN = 'TEST_SALE_CAMPAIGN',
  TRACK_ARROWS = 'TRACK_ARROWS',
  TRACK_BACKGROUND = 'TRACK_BACKGROUND',
  TRACK_COLOR_PICKER = 'TRACK_COLOR_PICKER',
  TRACK_GROUP_MODALS = 'TRACK_GROUP_MODAS',
  TRACK_IMAGES = 'TRACK_IMAGES',
  TRACK_INSERT = 'TRACK_INSERT',
  TRACK_INTERACTIVE_ELEMENTS = 'TRACK_INTERACTIVE_ELEMENTS',
  TRACK_INTERACTIVE_QUESTIONS = 'TRACK_INTERACTIVE_QUESTIONS',
  TRACK_PAGES = 'TRACK_PAGES',
  TRACK_REPLACE_MODAL = 'TRACK_REPLACE_MODAL',
  TRACK_RESOURCES = 'TRACK_RESOURCES',
  TRACK_SMARTBLOCKS = 'TRACK_SMARTBLOCKS',
  TRACK_TEXTS = 'TRACK_TEXTS',
  TRANSLATE_WITH_AI = 'TRANSLATE_WITH_AI',
  WIDGETS_CAMPAIGN = 'WIDGETS_CAMPAIGN',
  WIDGET_DEVELOPER = 'WIDGET_DEVELOPER',
  WIDGET_EDITOR = 'WIDGET_EDITOR',
}
